import React from 'react'

import MainTemplate from './components/MainTemplate/MainTemplate';
import { Box, Grid, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Heading from './components/Heading/Heading';
import { currentYear } from './utils/years';

const Confirmation = () => {
  const StudentDetailsColumns = [
    { field: 'StudentID', headerName: 'Student ID', flex: 1 },
    { field: 'FirstName', headerName: 'First Name', flex: 1 },
    { field: 'LastName', headerName: 'Last Name', flex: 1 },
    { field: 'YearLevel', headerName: `${currentYear()} Year Level`, flex: 1 }
  ];

  const StudentDetailsData = [
    { id: '1', StudentID: '21354', FirstName: 'Maryam', LastName: 'Abdelaal', YearLevel: 'Y11' },
    { id: '2', StudentID: '21393', FirstName: 'Dareen', LastName: 'Abdelaal', YearLevel: 'Y8' },
    { id: '3', StudentID: '21394', FirstName: 'Ammar', LastName: 'Abdelaal', YearLevel: 'Y4' }
  ];
  const content = (
    <>
      <Heading text={'Confirmation Receipt'} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography component="p" sx={{ fontSize: '14px', color: '#242424' }}>Parent Code: 18997</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography component="p" sx={{ fontSize: '14px', color: '#242424' }}>Re-enroled no. of children in AIC: 02</Typography>
        </Grid>
      </Grid>

      <DataGrid
        disableRowSelectionOnClick={true}
        className='pd-sign-tbl'
        rows={StudentDetailsData}
        columns={StudentDetailsColumns}
        autoHeight={true}
        checkboxSelection={false}
        rowClassName={() => {
          'datarow';
        }}
        sx={{
          '&.MuiDataGrid-root .MuiDataGrid-row': {
            height: '8em'
          },
          '&.MuiDataGrid-root .MuiSvgIcon-root': {
            color: '#242424',
            opacity: '1 !important',
          },
          '&.MuiDataGrid-root .MuiDataGrid-cellContent': {
            overflow: 'visible',
            textOverflow: 'ellipsis'
          },
          '&.MuiDataGrid-root .MuiTablePagination-displayedRows': {
            color: '#242424',
          },
          '@media (min-width: 900px)': {
            '&.MuiDataGrid-root .MuiDataGrid-row': {
              height: '4em'
            }
          },
          color: '#242424',
        }}
        getRowHeight={() => 'auto'}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
      />

      <Grid container mt={1} spacing={2}>
        <Grid item sm={6} xs={12}>
          <Box>
            <Typography component="p" sx={{ fontSize: '14px', color: '#242424' }}>Amount paid: 3500</Typography>
            <Typography component="p" sx={{ fontSize: '14px', color: '#242424' }}>*Confirmation Receipt is sent to your email.</Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
  return (
    <MainTemplate college={'Kewdale'} content={content} />
  )
}

export default Confirmation